import { api } from "../api";

/**
 * checklistFindLastExportResponse - Function that finds on database the last checklist and export in a PDF/XSLX file  
 * method GET  
 * @async-function
 */
const checklistFindLastExportResponse = async (token: string, customerId: number, selectedVehicleId: number, exportType: string, simpleXlsxExport = false) => {
    const response = await api.get(
        `/checklists/last/${customerId}/${selectedVehicleId}/${exportType}/export?simpleXlsxExport=${simpleXlsxExport}`, {
            responseType: "arraybuffer",
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};
export default checklistFindLastExportResponse;